<script lang="ts">
	import { format } from 'svelte-i18n';
	import { IconButton } from '@Shelly/shelly-design-system';
	import BenchmarkTariffInfoModal from '../../modals/benchmark/BenchmarkTariffInfoModal.svelte';
	import type { EnergyTariff } from 'src/types/EnergyTariff';

	export let benchmarkTariff: EnergyTariff | null = null;
	export let isLoading: boolean = false;

	let showBenchmarkInfoModal = false;

	const handleClick = () => {
		if (benchmarkTariff && !isLoading) {
			showBenchmarkInfoModal = true;
		}
	};
</script>

<IconButton
	icon="fa-solid fa-circle-info"
	variant="help"
	class="benchmark-info-btn"
	disabled={isLoading || !benchmarkTariff}
	on:click={handleClick}
	aria-label={$format('energy_price_benchmark_info', {
		default: 'Benchmark-Tarifinformationen',
		locale: 'de',
	})}
	size="s"
/>

{#if benchmarkTariff && !isLoading}
	<BenchmarkTariffInfoModal bind:showModal={showBenchmarkInfoModal} {benchmarkTariff} />
{/if}

<style>
	.benchmark-info-btn {
		flex-shrink: 0;
	}
</style>
